import http from './httpService';

export function getWorkCenters() {
	return http.get('WorkCenter');
}
